import React, { FC, useState } from 'react';

import * as CSS from './course-styles';

type Par = number;
type HoleProps = {
  holeNumber: number;
  holeIndex: number;
  holePar?: number;
  holeStrokeIndex?: number;
  setCoursePar: (index: number, value: number) => void;
  setCourseSi: (index: number, value: number) => void;
};

export const Hole: FC<HoleProps> = ({ holeIndex, holeNumber, holePar = 4, holeStrokeIndex = 10, setCoursePar, setCourseSi }) => {
  const [par, setPar] = useState<Par>(holePar);
  const [strokeIndex, setStrokeIndex] = useState<number>(holeStrokeIndex);
  const decrementPar = () => {
    const newPar = par - 1;
    setPar(newPar);
    setCoursePar(holeIndex, newPar);
  };
  const incrementPar = () => {
    const newPar = par + 1;
    setPar(newPar);
    setCoursePar(holeIndex, newPar);
  };
  const decrementStrokeIndex = () => {
    const newIndex = strokeIndex - 1;
    setStrokeIndex(newIndex);
    setCourseSi(holeIndex, newIndex);
  };
  const incrementStrokeIndex = () => {
    const newIndex = strokeIndex + 1;
    setStrokeIndex(newIndex);
    setCourseSi(holeIndex, newIndex);
  };
  return (
    <div>
      <CSS.FlexRow>
        <CSS.HoleNumber>{holeNumber}</CSS.HoleNumber>
        <CSS.FlexRow>
          <CSS.CrementButton data-testid={`hole-${holeNumber}-par-decrement`} onClick={() => decrementPar()} disabled={par === 1}>
            -
          </CSS.CrementButton>
          <CSS.HolePar data-testid={`hole-${holeNumber}-par`}>{par}</CSS.HolePar>

          <CSS.CrementButton data-testid={`hole-${holeNumber}-par-increment`} onClick={() => incrementPar()} disabled={par === 5}>
            +
          </CSS.CrementButton>
        </CSS.FlexRow>
        <CSS.FlexRow>
          <CSS.CrementButton data-testid={`hole-${holeNumber}-si-decrement`} onClick={() => decrementStrokeIndex()} disabled={strokeIndex === 1}>
            -
          </CSS.CrementButton>
          <CSS.HoleStrokeIndex data-testid={`hole-${holeNumber}-si`}>{strokeIndex}</CSS.HoleStrokeIndex>

          <CSS.CrementButton data-testid={`hole-${holeNumber}-si-increment`} onClick={() => incrementStrokeIndex()} disabled={strokeIndex === 18}>
            +
          </CSS.CrementButton>
        </CSS.FlexRow>
      </CSS.FlexRow>
    </div>
  );
};
